import { createTheme, ThemeOptions } from '@mui/material/styles';

const palette = {
  grey: {
    100: '#E5E5E5',
    200: '#E6E6E6',
    300: '#E7E7E7',
    400: '#F8F8F8',
    500: '#F5F5F5',
    600: '#ddd', // borders
    700: '#777',
  },
  black: {
    main: '#333',
    dark: '#555',
    light: '#777',
  },
  blue: {
    main: '#304368',
    light: '#337ab7',
    dark: '#23527c',
    contrastText: '#5bc0de',
  },
  accentColor: {
    light: '#d58d80',
    main: '#fd7b64',
  },
  green: {
    backgroundLight: '#dff0d8',
    light: '#a8d7a1',
    main: '#4fe637',
    contrastText: '#3c763d',
  },
  red: {
    light: '#f2dede',
    main: '#a94442',
    contrastText: '#ff006a',
  },
};

const themeOptions: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 768, // changed
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette,
  typography: {
    allVariants: {
      // default values
      color: palette.black.main,
      fontFamily: '"Open Sans", sans-serif',
      fontSize: 14,
    },
    h6: {
      fontSize: 18,
      fontWeight: 500,
    },
    h5: {
      fontSize: 24,
      fontWeight: 600,
    },
    h4: {
      fontSize: 34,
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 400,
      color: palette.black.light,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
    },
    faded: {
      opacity: 0.8,
      fontWeight: 600,
    },
    noData: {
      opacity: 0.4,
      fontWeight: 600,
      fontSize: 16,
    },
    navLink: {
      fontSize: 14,
      color: palette.blue.main,
      fontWeight: 500,
      whiteSpace: 'nowrap',
    },
    tableCell: {
      color: palette.black.dark,
      fontWeight: 500,
    },
    iconCell: {
      color: palette.black.dark,
      fontSize: 13,
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            borderColor: palette.grey[600],
            color: palette.black.main,
            padding: '4px 12px',
            textDecoration: 'none',
          },
        },
        {
          props: { variant: 'contained' },
          style: {
            padding: '4px 12px',
          },
        },
      ],
    },
    MuiTabs: { variants: [{ props: {}, style: { minHeight: 40 } }] },
    MuiTab: {
      variants: [{ props: {}, style: { minHeight: '40px' } }],
    },
  },
};

export const theme = createTheme(themeOptions);
